import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent, createRef } from 'react';
import { addResizeEndListener, removeResizeEndListener, getDimensions } from 'utils';
import { Container } from './styles';
import { jsx as _jsx } from "react/jsx-runtime";

var ContainerDimensions = /*#__PURE__*/function (_PureComponent) {
  _inherits(ContainerDimensions, _PureComponent);

  var _super = _createSuper(ContainerDimensions);

  function ContainerDimensions() {
    var _this;

    _classCallCheck(this, ContainerDimensions);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      width: 0,
      height: 0,
      screenWidth: 0,
      screenHeight: 0
    };
    _this.wrapper = /*#__PURE__*/createRef();

    _this.onResize = function () {
      var _getDimensions = getDimensions(_this.wrapper.current),
          width = _getDimensions.width,
          height = _getDimensions.height;

      var _document$documentEle = document.documentElement,
          screenWidth = _document$documentEle.clientWidth,
          screenHeight = _document$documentEle.clientHeight;

      _this.setState({
        width: width,
        height: height,
        screenWidth: screenWidth,
        screenHeight: screenHeight
      });
    };

    return _this;
  }

  _createClass(ContainerDimensions, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onResize();
      this.listener = addResizeEndListener(this.wrapper.current, this.onResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      removeResizeEndListener(this.wrapper.current, this.listener);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return /*#__PURE__*/_jsx(Container, {
        ref: this.wrapper,
        children: children(this.state)
      });
    }
  }]);

  return ContainerDimensions;
}(PureComponent);

export default ContainerDimensions;